import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f7c70db"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "29.9999",
    cy: "29.9999",
    r: "25.5556",
    fill: "#F7981C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M28.333 16.1113V31.6669H42.7775",
    stroke: "white",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "取消支付", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { ref } from 'vue'
import { isApp } from '@/utils/app'
import { useRoute, useRouter } from 'vue-router'
import { IframeWrapWindowtHistoryKey } from '@/config/constant'
import { useActiveHandle } from '@/compositions/insurance/useActiveHandle'
import AppHeader from '@/components/Header.vue'
import wx from 'weixin-js-sdk'


export default /*#__PURE__*/_defineComponent({
  __name: 'cancel-pay-return',
  setup(__props) {

// 取消支付返回得页面中转页
const $route = useRoute()
const $router = useRouter()
const showCancelContent = ref(false)
const eqSn = $route.query.eqSn as string
const client = $route.query.client as string
const activeKey = $route.query.activeKey as string
const isFromActive = $route.query.type === 'active'
const isMiniProgram = $route.query.mini === 'member'
const { activeHandle } = useActiveHandle(eqSn, client, activeKey)
if (isMiniProgram) {
  try {
    // wx.miniProgram.reLaunch({
    //   url: '/pages/pingan/epcis/cpc/redirect?jumpTag=deviceList',
    //   fail: (e) => {
    //     console.log('e', e)
    //   },
    // })
    localStorage.setItem('isCancelPayed', '1')
    wx.miniProgram.navigateBack({
      delta: 2,
      url: '',
    })
  } catch (error) {
    console.log('error', error)
  }
} else if (isApp) {
  // 如果不是外部浏览器打开的，理论上可以直接跳转到设备选择页
  if (isApp && isFromActive) {
    // app端激活流程处理
    activeHandle()
  } else {
    // $router.replace({
    //   name: 'insurance-jijia-device-select',
    //   query: {
    //     eqSn,
    //   },
    // })
    showCancelContent.value = true
  }
} else {
  // 一般是外部浏览器的场景
  showCancelContent.value = true
}
function onLeftClick() {
  const startLength = Number(sessionStorage.getItem(IframeWrapWindowtHistoryKey))
  $router.go(-1 * (window.history.length - startLength + 1))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showCancelContent.value)
      ? (_openBlock(), _createBlock(AppHeader, {
          key: 0,
          title: "取消支付",
          onLeftClick: onLeftClick,
          isReturnLeftEvent: ""
        }))
      : _createCommentVNode("", true),
    (showCancelContent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})